import { R7E_PublisherApplication, R7eAccountTypeError, r7eBaseApp } from './r7e';

// console.log("r7eBaseApp=", r7eBaseApp);
// const r7eApp = new R7E_PublisherApplication(r7eBaseApp);
// console.log("r7eApp=", r7eApp);
// console.log("r7eApp.base", r7eApp.base);


const new_r7eApplication = () => {
    return new R7E_PublisherApplication(r7eBaseApp);
}

import { inject } from 'vue'
const getR7eApp = () => {
    const r7eApp = inject('r7eApp');
    // console.log('getR7eApp, r7eApp ==', r7eApp);
    return r7eApp;
}

export {R7eAccountTypeError, R7E_PublisherApplication, new_r7eApplication, getR7eApp };
export default {R7eAccountTypeError, R7E_PublisherApplication, new_r7eApplication, getR7eApp }
